export default __webpack_public_path__ + "locales/sr-Latn-RS/Payments.json?hash=7956f5aba96938f2c58bd97da0ff29a0";